// Shared logic for Time and AllocationStamp

import { ISO11783Version } from './types';

export function parseXMLAttributes(
  startAttr: string,
  stopAttr: string,
  durationAttr: string,
  version: ISO11783Version
) {
  const postfix = version === 4 ? '' : 'Z';
  const startStr = startAttr + postfix;
  const stopStr = stopAttr ? stopAttr + postfix : null;
  const duration = durationAttr ? parseInt(durationAttr, 10) : null;

  return {
    start: +new Date(startStr),
    stop: +new Date(stopStr),
    duration,
  };
}

export function encodeXMLAttributes(
  start: number,
  stop: number,
  duration: number,
  version: ISO11783Version
) {
  let startStr = new Date(start).toISOString();
  let stopStr = stop && new Date(stop).toISOString();

  if (version === 3) {
    // remove "Z" at the end
    startStr = startStr.slice(0, -1);
    stopStr = stopStr && stopStr.slice(0, -1);
  }

  return { startStr, stopStr, durationStr: duration ? duration.toString() : null };
}
